import { createEntityComboBox } from './helpers/createEntityComboBox';
import { useServicesList, SelectableService } from './SelectServiceTouch';

export const SelectService = createEntityComboBox.remotelySearched(
  'SelectService',
  useServicesList,
  {
    formatLabel: (entity: SelectableService) => `#${entity.documentNumber}`,
    formatSubLabel: (entity: SelectableService) => entity.status,
  },
);
